import React from 'react'
import Collection from '../common/collection'

function CollectionT({ props }) {
  return (
    <Collection
      vertical
      src={['https://volverse-negro-daniel.s3.amazonaws.com/images/19.+ni%C3%B1ocielo15.jpg']}
      alt="Niño cielo"
    />
  )
}


export default CollectionT
